/**
 * SafetyMarginSlider — "Operational Safety Margin": how much spare capacity
 * the recommendations should keep (legacy `headroom`).
 *
 * Port of legacy views/ManagePortfolio/Instances.vue (:17-23): 0–100 in steps
 * of 10, starting at 20. Moving it calls NO API — the value is only kept by the
 * page and sent with Upload and Save, where the server uses it.
 *
 * Built on the design system's Slider (a native range input with the teal
 * thumb); the track is filled teal up to the thumb, as in the app's design.
 */
import { useId } from 'react';

import { Slider } from '@components/ui';

import { HEADROOM_MAX, HEADROOM_MIN, HEADROOM_STEP } from '../portfolioFormRules';

import styles from './SafetyMarginSlider.module.css';

export function SafetyMarginSlider({ value, onChange, disabled = false }) {
  const id = useId();
  const percent = ((value - HEADROOM_MIN) / (HEADROOM_MAX - HEADROOM_MIN)) * 100;

  return (
    <div className={styles.safetyMargin}>
      {/* The value sits BESIDE the label, not inside it: an <output> is itself
          labelable, so inside the <label> it took the slider's name too and a
          screen reader met two "Operational Safety Margin" controls. */}
      <span className={styles.label}>
        <label htmlFor={id}>Operational Safety Margin</label> <span aria-hidden="true">—</span>{' '}
        <output htmlFor={id} className={styles.value}>
          {value}
        </output>
      </span>
      <Slider
        id={id}
        className={styles.slider}
        min={HEADROOM_MIN}
        max={HEADROOM_MAX}
        step={HEADROOM_STEP}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange?.(Number(e.target.value))}
        aria-valuetext={`${value} percent spare capacity`}
        // How far to fill the track teal — the thumb's position.
        style={{ '--fill': `${percent}%` }}
      />
    </div>
  );
}

export default SafetyMarginSlider;
